var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrap result-wrap" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "icon loading" }),
      _c("div", { staticClass: "text" }, [_vm._v(_vm._s(_vm.$t("loginning")))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }